import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { OutboundEmailSummary, Pagination } from '@/types';
import { EmailRow } from './EmailRow';
import { EmailsPagination } from './EmailsPagination';
import { EmailsSearch } from './EmailsSearch';

interface EmailListProps {
  emails: OutboundEmailSummary[];
  pagination: Pagination;
  search: string | null;
}

const dateFormat = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function EmailList({ emails, pagination, search }: EmailListProps) {
  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        <div className="flex-1">
          <EmailsSearch search={search} />
        </div>
      </div>

      {emails.length === 0 ? (
        <div className="py-6 text-center text-muted-foreground">
          {search
            ? `No emails found matching "${search}".`
            : 'No emails have been sent yet.'}
        </div>
      ) : (
        <>
          <div className="rounded-md border">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Template</TableHead>
                  <TableHead>To</TableHead>
                  <TableHead>Subject</TableHead>
                  <TableHead>Status</TableHead>
                  <TableHead>Sent At</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {emails.map((email) => (
                  <EmailRow
                    key={email.id}
                    email={{
                      id: email.id,
                      templateName: email.templateName,
                      to: email.to,
                      subject: email.subject,
                      status: email.status,
                      formattedDate: dateFormat.format(
                        new Date(email.sentAt ?? email.createdAt),
                      ),
                    }}
                  />
                ))}
              </TableBody>
            </Table>
          </div>

          <EmailsPagination
            currentPage={pagination.page}
            totalPages={pagination.totalPages}
            total={pagination.total}
            search={search}
          />
        </>
      )}
    </div>
  );
}
